// Sistema de Membresías AV 10 de Julio
// Basado en el documento del proyecto

// ── Agente Mecánico IA — límites por plan de cliente ──
export const AI_AGENT_LIMITS = {
  visitor: { consultas: 2, label: '2 preguntas al día' },
  basic: { consultas: 30, label: '30 interacciones al mes' },
  dashboard_base: { consultas: 30, label: '30 interacciones al mes' },
  premium: { consultas: 100, label: '100 interacciones al mes' },
  premium_conductor: { consultas: 100, label: '100 interacciones al mes' },
  premium_vehicular: { consultas: 500, label: '500 interacciones al mes' },
};

// ── Addon: vehículos adicionales por plan ($CLP/mes c/u, duración 30 días) ──
export const ADDON_VEHICULO_BASE_PRICE       = 3990;  // Dashboard Base mensual (1 incluido)
export const ADDON_VEHICULO_BASE_ANUAL_PRICE = 39900; // Dashboard Base anual 1 vehículo (10 meses pagando, 12 de vigencia)
export const ADDON_VEHICULO_PREMIUM_PRICE   = 2990; // Premium Conductor (3 incluidos)
export const ADDON_VEHICULO_VEHICULAR_PRICE = 1990; // Premium Vehicular (10 incluidos)

// ── Precios anuales con descuento ──
export const CLIENT_ANNUAL_PRICING = {
  visitor: { price: 0, monthlyEquivalent: 0, savings: 0, discountPercent: 0 },
  basic: { price: 49990, monthlyEquivalent: Math.round(49990 / 12), savings: (4990 * 12) - 49990, discountPercent: Math.round(((4990 * 12 - 49990) / (4990 * 12)) * 100) },
  premium: { price: 119990, monthlyEquivalent: Math.round(119990 / 12), savings: (12990 * 12) - 119990, discountPercent: Math.round(((12990 * 12 - 119990) / (12990 * 12)) * 100) },
  premium_vehicular: { price: 239990, monthlyEquivalent: Math.round(239990 / 12), savings: (24990 * 12) - 239990, discountPercent: Math.round(((24990 * 12 - 239990) / (24990 * 12)) * 100) },
};

export const MEMBERSHIP_PLANS = {
  FREE: {
    id: 'free',
    name: 'Plan Gratuito',
    price: 0,
    currency: 'CLP',
    description: 'Perfil público básico para empresas validadas',
    features: [
      'Perfil público en la plataforma',
      'Hasta 5 productos activos',
      'Hasta 2 campañas mensuales',
      'Métricas básicas de visitas',
      'Sello de empresa validada AV 10 de Julio',
      'Soporte por email'
    ],
    limitations: {
      maxProducts: 5,
      maxCampaigns: 2,
      maxCampaignsPerMonth: 2,
      analyticsLevel: 'basic',
      supportLevel: 'email',
      customBranding: false,
      advancedCampaigns: false,
      prioritySupport: false,
      advisorAccess: false,
      eventAccess: false,
      discountServices: false
    },
    color: 'gray',
    popular: false
  },

  PREMIUM: {
    id: 'premium',
    name: 'Plan Premium',
    price: 6990,
    currency: 'CLP',
    description: 'Herramientas avanzadas para crecimiento empresarial',
    features: [
      'Perfil destacado en la plataforma',
      'Productos y campañas ilimitadas',
      'Campañas avanzadas (segmentadas, automatizadas)',
      'Métricas avanzadas y reportes personalizados',
      'Asesoría mensual con especialista',
      'Participación en campañas masivas',
      'Acceso a capacitaciones y eventos',
      'Soporte prioritario',
      'Descuentos en servicios extra (branding, herramientas)',
      'Sello de calidad premium',
      'Analytics avanzados por marca/modelo'
    ],
    limitations: {
      maxProducts: -1, // Ilimitado
      maxCampaigns: -1, // Ilimitado
      maxCampaignsPerMonth: -1, // Ilimitado
      analyticsLevel: 'advanced',
      supportLevel: 'priority',
      customBranding: true,
      advancedCampaigns: true,
      prioritySupport: true,
      advisorAccess: true,
      eventAccess: true,
      discountServices: true
    },
    color: 'blue',
    popular: true
  },

  CORPORATE: {
    id: 'corporate',
    name: 'Plan Marca/Corporativo',
    price: 12990,
    currency: 'CLP',
    description: 'Solución completa para franquicias y grandes empresas',
    features: [
      'Todo del plan Premium',
      'Reportes por marca/modelo específicos',
      'Integraciones avanzadas con sistemas existentes',
      'Condiciones especiales para franquicias/sucursales',
      'API de integración',
      'Dashboard multi-empresa',
      'Gestión centralizada de campañas',
      'Soporte dedicado 24/7',
      'Capacitaciones personalizadas',
      'Eventos exclusivos corporativos',
      'Descuentos especiales en servicios premium'
    ],
    limitations: {
      maxProducts: -1, // Ilimitado
      maxCampaigns: -1, // Ilimitado
      maxCampaignsPerMonth: -1, // Ilimitado
      analyticsLevel: 'enterprise',
      supportLevel: 'dedicated',
      customBranding: true,
      advancedCampaigns: true,
      prioritySupport: true,
      advisorAccess: true,
      eventAccess: true,
      discountServices: true,
      apiAccess: true,
      multiCompany: true,
      centralManagement: true
    },
    color: 'purple',
    popular: false
  },

  ENTERPRISE: {
    id: 'enterprise',
    name: 'Plan Enterprise',
    price: 12990,
    currency: 'CLP',
    description: 'Ideal para talleres y empresas con alto volumen: hasta 100 productos y 30 campañas',
    features: [
      'Hasta 100 productos activos',
      'Hasta 30 campañas',
      'Todo lo del plan Premium',
      'Métricas avanzadas y reportes',
      'Soporte prioritario',
      'Asesoría y eventos'
    ],
    limitations: {
      maxProducts: 100,
      maxCampaigns: 30,
      maxCampaignsPerMonth: 30,
      analyticsLevel: 'advanced',
      supportLevel: 'priority',
      customBranding: true,
      advancedCampaigns: true,
      prioritySupport: true,
      advisorAccess: true,
      eventAccess: true,
      discountServices: true
    },
    color: 'purple',
    popular: false
  }
};

/**
 * PLANES DE CLIENTE – Fuente de verdad única.
 * Operación manual: sin consultas de patente ni integraciones API (multas/TAG/SOAP/permiso/revisión por API).
 * Gratuito: 2 vehículos, recordatorios por email, 10 gastos/mes, soporte email, analytics básico.
 * Premium: 10 vehículos, recordatorios ilimitados, gastos ilimitados, asesoría, soporte prioritario, analytics avanzado.
 */
export const CLIENT_MEMBERSHIP_PLANS = {
  BASIC: {
    id: 'basic',
    name: 'Dashboard Base',
    price: 4990,
    currency: 'CLP',
    description: 'Dashboard inteligente para administrar tu vehículo con el Agente Mecánico IA',
    features: [
      'Copiloto IA · 30 interacciones/mes',
      '1 vehículo incluido',
      'Documentos: Cédula, Licencia, Revisión Técnica, Permiso, SOAP, Padrón',
      'Mantenciones: Aceite, Frenos, Neumáticos, Batería, KM, Preventiva, Reparación',
      'Gastos: Combustible, TAG/Peajes, Seguro, Multas, Accesorios, Repuestos, Limpieza, Otro',
      'Actualizar KM · Para recomendaciones',
      'Ver peajes · Valores de Chile actualizados',
      'Calcular viaje con peaje incluido',
      'Vehículo adicional por $3.990/mes',
      'Panel de combustible semanal',
      'Restricción vehicular · Región Metropolitana',
      'Calendario de Revisión Técnica',
      'Talleres, plantas RT, vulcanizaciones y más',
    ],
    limitations: {
      maxVehiculos: 1,
      vehiclesMax: 1,
      plateChecksMaxMonthly: 0,
      maxGastosMonthly: -1,
      maxRecordatorios: -1,
      remindersByEmailOnly: true,
      maxConsultasPatente: 0,
      maxGastos: 10,
      maxCotizaciones: 0,
      personalizedPromos: false,
      autoReminders: true,
      exclusiveEvents: false,
      advisorAccess: false,
      specialDiscounts: false,
      pushNotifications: false,
      prioritySupport: false,
      supportLevel: 'email',
      analyticsLevel: 'basic',
      consultaVehiculo: false,
      gestionGastos: true,
      multasYTag: false
    },
    premiumUpgradeBenefits: [
      '100 interacciones/mes con el Copiloto IA',
      'Hasta 3 vehículos incluidos',
      'Consulta de Patentes · 10/mes',
      'TAG/Autopistas y Multas · 1x semana por vehículo',
      'Vehículo adicional por $2.990/mes'
    ]
  },

  PREMIUM: {
    id: 'premium',
    name: 'Premium Conductor',
    price: 12990,
    currency: 'CLP',
    description: 'Más continuidad, más vehículos y uso intensivo del Copiloto IA',
    features: [
      'Copiloto IA · 100 interacciones/mes',
      'Hasta 3 vehículos incluidos',
      'Documentos: Cédula, Licencia, Revisión Técnica, Permiso, SOAP, Padrón',
      'Mantenciones: Aceite, Frenos, Neumáticos, Batería, KM, Preventiva, Reparación',
      'Gastos: Combustible, TAG/Peajes, Seguro, Multas, Accesorios, Repuestos, Limpieza, Otro',
      'Actualizar KM · Para recomendaciones',
      'Ver peajes · Valores de Chile actualizados',
      'Calcular viaje con peaje incluido',
      'Vehículo adicional por $2.990/mes',
      'Panel de combustible semanal',
      'Restricción vehicular · Región Metropolitana',
      'Calendario de Revisión Técnica',
      'Talleres, plantas RT, vulcanizaciones y más',
      'Consulta de Patentes · 10/mes',
      'Consulta TAG/Autopistas · 1x semana por vehículo',
      'Consulta de Multas · 1x semana por vehículo',
    ],
    limitations: {
      maxVehiculos: 3,
      vehiclesMax: 3,
      plateChecksMaxMonthly: 10,
      maxGastosMonthly: -1,
      maxRecordatorios: -1,
      remindersByEmailOnly: false,
      maxConsultasPatente: 10,
      maxGastos: -1,
      maxCotizaciones: 5,
      personalizedPromos: true,
      autoReminders: true,
      exclusiveEvents: true,
      advisorAccess: true,
      specialDiscounts: true,
      pushNotifications: true,
      prioritySupport: true,
      supportLevel: 'priority',
      analyticsLevel: 'advanced',
      consultaVehiculo: true,
      gestionGastos: true,
      multasYTag: true
    }
  },

  PREMIUM_VEHICULAR: {
    id: 'premium_vehicular',
    name: 'Premium Vehicular',
    price: 24990,
    currency: 'CLP',
    description: 'Máxima capacidad: más vehículos, más consultas y Copiloto IA intensivo',
    features: [
      'Copiloto IA · 500 interacciones/mes',
      'Hasta 10 vehículos incluidos',
      'Documentos: Cédula, Licencia, Revisión Técnica, Permiso, SOAP, Padrón',
      'Mantenciones: Aceite, Frenos, Neumáticos, Batería, KM, Preventiva, Reparación',
      'Gastos: Combustible, TAG/Peajes, Seguro, Multas, Accesorios, Repuestos, Limpieza, Otro',
      'Actualizar KM · Para recomendaciones',
      'Ver peajes · Valores de Chile actualizados',
      'Calcular viaje con peaje incluido',
      'Vehículo adicional por $1.990/mes',
      'Panel de combustible semanal',
      'Restricción vehicular · Región Metropolitana',
      'Calendario de Revisión Técnica',
      'Talleres, plantas RT, vulcanizaciones y más',
      'Consulta de Patentes · 100/mes',
      'Consulta TAG/Autopistas · 1x semana por vehículo',
      'Consulta de Multas · 1x semana por vehículo',
    ],
    limitations: {
      maxVehiculos: 10,
      vehiclesMax: 10,
      plateChecksMaxMonthly: 100,
      maxGastosMonthly: -1,
      maxRecordatorios: -1,
      remindersByEmailOnly: false,
      maxConsultasPatente: 100,
      maxGastos: -1,
      maxCotizaciones: 10,
      personalizedPromos: true,
      autoReminders: true,
      exclusiveEvents: true,
      advisorAccess: true,
      specialDiscounts: true,
      pushNotifications: true,
      prioritySupport: true,
      supportLevel: 'priority',
      analyticsLevel: 'advanced',
      consultaVehiculo: true,
      gestionGastos: true,
      multasYTag: true
    }
  }
};

/** Filas de la tabla de comparación de planes cliente (desde fuente de verdad) */
export const CLIENT_PLAN_COMPARISON_ROWS = [
  { key: 'vehiculos',      label: 'Vehículos',          basic: '1',           premium: '3',            vehicular: '10' },
  { key: 'copiloto',       label: 'Copiloto IA',         basic: '30/mes',      premium: '100/mes',      vehicular: '500/mes' },
  { key: 'documentos',     label: 'Documentos',          basic: 'Sí',          premium: 'Sí',           vehicular: 'Sí' },
  { key: 'gastos',         label: 'Gastos y mantenciones', basic: 'Ilimitados', premium: 'Ilimitados',  vehicular: 'Ilimitados' },
  { key: 'peajes',         label: 'Peajes / Calcular viaje', basic: 'Sí',      premium: 'Sí',           vehicular: 'Sí' },
  { key: 'patente',        label: 'Consulta de patente', basic: '—',           premium: '10/mes',       vehicular: '100/mes' },
  { key: 'multasTag',      label: 'Multas y TAG',        basic: '—',           premium: '1x sem/veh',   vehicular: '1x sem/veh' },
  { key: 'addon',          label: 'Vehículo adicional',  basic: '$3.990/mes',  premium: '$2.990/mes',   vehicular: '$1.990/mes' },
  { key: 'soporte',        label: 'Soporte',             basic: 'Email',       premium: 'Prioritario',  vehicular: 'Prioritario' },
];

/** Límites por plan CLIENTE (consultas de patente/API deshabilitadas en producto) */
export const getClientPlanLimits = (plan) => {
  const p = (plan || 'basic').toLowerCase();
  if (p === 'premium_vehicular' || p === 'vehicular') {
    return {
      vehiclesMax: 10,
      plateChecksMaxMonthly: 100,
      maxGastosMonthly: -1,
      multasYTag: true,
      advisorAccess: true,
      supportLevel: 'priority',
      analyticsLevel: 'advanced'
    };
  }
  if (p === 'premium' || p === 'premium_conductor') {
    return {
      vehiclesMax: 3,
      plateChecksMaxMonthly: 10,
      maxGastosMonthly: -1,
      multasYTag: true,
      advisorAccess: true,
      supportLevel: 'priority',
      analyticsLevel: 'advanced'
    };
  }
  return {
    vehiclesMax: 1,
    plateChecksMaxMonthly: 0,
    maxGastosMonthly: -1,
    multasYTag: false,
    advisorAccess: false,
    supportLevel: 'email',
    analyticsLevel: 'basic'
  };
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'activa',
  EXPIRED: 'expirada',
  CANCELLED: 'cancelada',
  PENDING: 'pendiente',
  TRIAL: 'en_prueba'
};

export const BILLING_CYCLES = {
  MONTHLY: 'mensual',
  YEARLY: 'anual',
  QUARTERLY: 'trimestral'
};

export const METRICS_TYPES = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
  ENTERPRISE: 'enterprise'
};

export const SUPPORT_LEVELS = {
  EMAIL: 'email',
  PRIORITY: 'priority',
  DEDICATED: 'dedicated'
};

// Funciones de utilidad
export const getPlanById = (planId) => {
  return MEMBERSHIP_PLANS[planId.toUpperCase()] || MEMBERSHIP_PLANS.FREE;
};

export const getClientPlanById = (planId) => {
  const normalized = String(planId || 'basic').toUpperCase();
  if (normalized === 'DASHBOARD_BASE' || normalized === 'BASE') return CLIENT_MEMBERSHIP_PLANS.BASIC;
  if (normalized === 'PREMIUM_CONDUCTOR') return CLIENT_MEMBERSHIP_PLANS.PREMIUM;
  return CLIENT_MEMBERSHIP_PLANS[normalized] || CLIENT_MEMBERSHIP_PLANS.BASIC;
};

export const canUpgrade = (currentPlan, targetPlan) => {
  const plans = Object.values(MEMBERSHIP_PLANS);
  const currentIndex = plans.findIndex(p => p.id === currentPlan);
  const targetIndex = plans.findIndex(p => p.id === targetPlan);
  return targetIndex > currentIndex;
};

export const getPlanLimits = (planId) => {
  const plan = getPlanById(planId);
  return plan.limitations;
};

export const formatPrice = (price, currency = 'CLP') => {
  if (price === 0) return 'Gratis';
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: currency
  }).format(price);
};

export const getPlanColor = (planId) => {
  const plan = getPlanById(planId);
  return plan.color;
};

export const isPopularPlan = (planId) => {
  const plan = getPlanById(planId);
  return plan.popular;
};
